import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

// currently disabled after new market requirements
const isAutoDisplay3dExhibitionEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('e3dAutoDisplaySharingDashboard'),
)

export default isAutoDisplay3dExhibitionEnabledSelector
